const countryCustomField = [
    {
        field_name: 'name',
        label: 'Country',
        type: "string",
        isRequired: true
    },
    {
        field_name: 'status',
        label: 'Status',
        type: "string",
        isRequired: true
    }
];



export const Constant = {
    countryCustomField
}
